export interface ReportAuxiliaryLocationState {
  isReadOnly?: boolean;
  workflowRunUuid?: string;
  fromPath?: string;
}

/** True when navigation stays on pages scoped to the same report id. */
export function isNavigatingWithinReportScope(
  pathname: string,
  reportId: string | undefined
): boolean {
  if (!reportId) return false;
  return (
    pathname.includes(`/reports/${reportId}`) ||
    pathname.includes(`/360/${reportId}`)
  );
}

export function getFallbackWorkflowRunUuid(state: unknown): string | undefined {
  const auxiliaryState = state as ReportAuxiliaryLocationState | null;
  return auxiliaryState?.workflowRunUuid;
}

/** Resolve whether the auxiliary leave blocker should defer until report data exists. */
export function resolveAuxiliaryReportLoading(
  id: string | undefined,
  report: unknown,
  isReportError: boolean,
  parentProvidesReport: boolean,
  parentReportLoading: boolean | undefined,
  fetchedReportLoading: boolean
): boolean {
  if (parentProvidesReport) {
    return parentReportLoading === true || (!!id && !report && !isReportError);
  }
  return fetchedReportLoading || (!!id && !report && !isReportError);
}
